import { motion } from "framer-motion";
import { Reveal, SplitLines } from "./Reveal";
import { ZoomImage } from "./Lightbox";
import { Sparkles } from "./Sparkles";
import { SHAPES } from "../data/business";

export const Shapes = ({ onPick, number = "02" }) => (
  <section id="shapes" data-testid="shapes-section" className="relative py-24 lg:py-36 bg-[#0d0d0d] border-y border-gold/10 grain">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <div className="grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-4">
          <Reveal><p className="eyebrow mb-6">{number} — Shapes</p></Reveal>
          <h2 className="font-display font-light text-ivory text-[clamp(2.4rem,5vw,4.5rem)] leading-[0.95]">
            <SplitLines inView lines={["Ten cuts.", <span key="b" className="text-saffron italic">One standard.</span>]} />
          </h2>
          <Reveal delay={0.2} className="mt-8 text-ivory/60 font-light leading-relaxed">
            Choosing a ring or filling a production order, the shape sets the mood: rounds for timeless sparkle, ovals and marquise that look larger on the hand,
            step cuts like Emerald and Asscher for quiet elegance. Tap a shape to explore it.
          </Reveal>
          <div className="mt-10 grid grid-cols-2 gap-x-6 gap-y-3" data-testid="shape-list">
            {SHAPES.map((s, i) => (
              <button
                key={s} data-testid={`shape-pick-${s.toLowerCase()}`}
                onClick={() => onPick(s)}
                className="group flex items-baseline gap-3 text-left py-1 border-b border-gold/10 hover:border-saffron/60 transition-colors"
              >
                <span className="text-[10px] tracking-[0.2em] text-gold/70 font-mono">{String(i + 1).padStart(2, "0")}</span>
                <span className="font-display text-xl text-ivory/85 group-hover:text-saffron transition-colors">{s}</span>
              </button>
            ))}
          </div>
        </div>

        <Reveal delay={0.15} className="lg:col-span-8">
          <motion.div
            whileHover={{ scale: 1.005 }} transition={{ duration: 0.6 }}
            className="relative border border-gold/25 p-2 sm:p-3 bg-night img-frame"
          >
            <div className="absolute -top-3 left-6 bg-night px-3 text-[10px] uppercase tracking-[0.3em] text-gold z-10">Reference chart · actual faceting</div>
            <div className="relative overflow-hidden">
              <ZoomImage
                src="/img/shapes.jpg" alt="Lab grown diamond shapes chart: Round brilliant, Oval, Emerald cut, Princess cut, Cushion, Pear, Marquise, Radiant, Asscher and Heart shape diamonds"
                data-testid="shapes-image" className="w-full h-auto block"
              />
              <Sparkles count={14} />
            </div>
            <div className="absolute inset-0 pointer-events-none shadow-[inset_0_0_120px_rgba(0,0,0,0.6)]" />
          </motion.div>
        </Reveal>
      </div>
    </div>
  </section>
);
